import { useEffect, useMemo, useState } from "react";
import LandingPhoneFrame from "./LandingPhoneFrame";
import s from "./homeLanding.module.css";

function FeatureArt({ kind, accent }) {
  switch (kind) {
    case "brand-logo":
      return (
        <div className={`${s.storyArt} ${s.storyArtBrandLogo}`} data-accent={accent}>
          <div className={s.storyArtPhone}>
            <div className={s.storyArtLogoRing}>
              <span>БС</span>
            </div>
            <div className={s.storyArtSwatches}>
              <i /><i /><i /><i />
            </div>
          </div>
        </div>
      );
    case "brand-splash":
      return (
        <div className={`${s.storyArt} ${s.storyArtBrandSplash}`} data-accent={accent}>
          <div className={s.storyArtSplash}>
            <div className={s.storyArtSplashOrb} />
            <div className={s.storyArtSplashLogo} />
            <div className={s.storyArtSplashLine} />
            <div className={s.storyArtSplashLineShort} />
          </div>
        </div>
      );
    case "brand-theme":
      return (
        <div className={`${s.storyArt} ${s.storyArtBrandTheme}`} data-accent={accent}>
          <div className={s.storyArtThemeSplit}>
            <div className={s.storyArtThemeDark}>
              <span />
              <span />
            </div>
            <div className={s.storyArtThemeLight}>
              <span />
              <span />
            </div>
          </div>
        </div>
      );
    case "social-home":
      return (
        <div className={`${s.storyArt} ${s.storyArtSocialHome}`} data-accent={accent}>
          <div className={s.storyArtCardRow}>
            <div className={s.storyArtMiniCard}>
              <strong>8</strong>
              <span>занятий</span>
            </div>
            <div className={s.storyArtMiniCard}>
              <strong>Завтра</strong>
              <span>16:00</span>
            </div>
          </div>
          <div className={s.storyArtPoll}>
            <span>Приду на тренировку?</span>
            <div>
              <b>Да</b>
              <b>Нет</b>
            </div>
          </div>
        </div>
      );
    case "social-profile":
      return (
        <div className={`${s.storyArt} ${s.storyArtSocialProfile}`} data-accent={accent}>
          <div className={s.storyArtAvatar} />
          <div className={s.storyArtMedals}>
            <i>🥇</i>
            <i>🥈</i>
            <i>🥉</i>
          </div>
          <div className={s.storyArtWallLines}>
            <span /><span /><span />
          </div>
        </div>
      );
    case "social-chat":
      return (
        <div className={`${s.storyArt} ${s.storyArtSocialChat}`} data-accent={accent}>
          <div className={`${s.storyArtBubble} ${s.storyArtBubbleLeft}`}>Тренировка в силе?</div>
          <div className={`${s.storyArtBubble} ${s.storyArtBubbleRight}`}>Да, буду!</div>
          <div className={`${s.storyArtBubble} ${s.storyArtBubbleLeft}`}>Отлично 👍</div>
        </div>
      );
    case "social-rating":
      return (
        <div className={`${s.storyArt} ${s.storyArtSocialRating}`} data-accent={accent}>
          <div className={s.storyArtPodium}>
            <div><strong>2</strong><span>Аня</span></div>
            <div className={s.storyArtPodiumFirst}><strong>1</strong><span>Иван</span></div>
            <div><strong>3</strong><span>Макс</span></div>
          </div>
        </div>
      );
    case "manage-summary":
      return (
        <div className={`${s.storyArt} ${s.storyArtManageSummary}`} data-accent={accent}>
          <div className={s.storyArtStats}>
            <div><strong>12</strong><span>сегодня</span></div>
            <div><strong>3</strong><span>опроса</span></div>
          </div>
          <div className={s.storyArtSession}>
            <span>16:00</span>
            <strong>Младшая группа</strong>
          </div>
        </div>
      );
    case "manage-calendar":
      return (
        <div className={`${s.storyArt} ${s.storyArtManageCalendar}`} data-accent={accent}>
          <div className={s.storyArtCalGrid}>
            {Array.from({ length: 14 }, (_, i) => (
              <i key={i} className={i === 5 || i === 9 ? s.storyArtCalDot : ""} />
            ))}
          </div>
        </div>
      );
    case "manage-clients":
      return (
        <div className={`${s.storyArt} ${s.storyArtManageClients}`} data-accent={accent}>
          {[1, 2, 3].map((n) => (
            <div key={n} className={s.storyArtClientRow}>
              <span className={s.storyArtClientAvatar} />
              <span className={s.storyArtClientLine} />
            </div>
          ))}
        </div>
      );
    case "manage-journal":
      return (
        <div className={`${s.storyArt} ${s.storyArtManageJournal}`} data-accent={accent}>
          {["✓", "✓", "—"].map((mark, i) => (
            <div key={i} className={s.storyArtJournalRow}>
              <span className={mark === "✓" ? s.storyArtJournalOk : s.storyArtJournalMiss}>
                {mark}
              </span>
              <span className={s.storyArtClientLine} />
            </div>
          ))}
        </div>
      );
    case "manage-finance":
      return (
        <div className={`${s.storyArt} ${s.storyArtManageFinance}`} data-accent={accent}>
          <div className={s.storyArtFinanceBars}>
            <i style={{ height: "42%" }} />
            <i style={{ height: "68%" }} />
            <i style={{ height: "55%" }} />
            <i style={{ height: "88%" }} />
          </div>
          <div className={s.storyArtFinanceTotal}>
            <strong>+124 000 ₽</strong>
            <span>за месяц</span>
          </div>
        </div>
      );
    default:
      return <div className={s.storyArt} data-accent={accent} />;
  }
}

export default function LandingStoryFeatureVisual({ section }) {
  const features = section.features || [];
  const [activeId, setActiveId] = useState(
    section.defaultFeatureId || features[0]?.id,
  );
  const [phase, setPhase] = useState("enter");

  const active = useMemo(
    () => features.find((f) => f.id === activeId) || features[0],
    [features, activeId],
  );

  useEffect(() => {
    setPhase("exit");
    const t = window.setTimeout(() => setPhase("enter"), 180);
    return () => window.clearTimeout(t);
  }, [activeId]);

  if (!active) return null;

  const accent = section.accent || "violet";
  const many = features.length > 4;

  return (
    <div className={s.storyFeatureVisual} aria-label={section.title}>
      <div className={`${s.storyFeatureGlow} ${s[`storyFeatureGlow_${accent}`]}`} aria-hidden />
      <div
        className={`${s.storyFeatureCard} ${s[`storyFeatureCard_${accent}`]} ${
          phase === "enter" ? s.storyFeatureCardEnter : s.storyFeatureCardExit
        }`}
      >
        {active.src ? (
          <div
            className={`${s.storyFeatureShot} ${
              active.phone === false ? s.storyFeatureShotDesktop : ""
            }`}
          >
            {active.phone === false ? (
              <div className={s.storyDesktopFrame}>
                <div className={s.storyDesktopInner}>
                  <img src={active.src} alt={active.title} loading="lazy" decoding="async" />
                </div>
              </div>
            ) : (
              <LandingPhoneFrame src={active.src} alt={active.title} size="sm" />
            )}
          </div>
        ) : (
          <FeatureArt kind={active.kind} accent={accent} />
        )}
        <div className={s.storyFeatureCopy}>
          <h4 className={s.storyFeatureTitle}>{active.title}</h4>
          <ul className={s.storyFeatureLines}>
            {(active.lines || []).map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        </div>
      </div>
      <div
        className={`${s.storyFeatureTabs} ${many ? s.storyFeatureTabsMany : ""}`}
        role="tablist"
        aria-label="Возможности"
      >
        {features.map((feature) => {
          const on = active.id === feature.id;
          return (
            <button
              key={feature.id}
              type="button"
              role="tab"
              aria-selected={on}
              className={on ? s.storyFeatureTabOn : s.storyFeatureTab}
              onClick={() => setActiveId(feature.id)}
            >
              {feature.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
